import React, { ReactChild } from 'react';

type ColumnDefinition<T> = {
    id?: string;
    header: React.ReactNode;
    cell(item: T): React.ReactNode;
    width?: number | string;
    minWidth?: number | string;
    maxWidth?: number | string;
};

interface Props {
    columnDefinitions: ColumnDefinition<any>[];
    items: any[];
    emptyState?: ReactChild;
    tableTitle: ReactChild;
    tableId?: string;
}

class NativeHtmlTable extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const { columnDefinitions, emptyState, items, tableTitle, tableId } = this.props;

        const thead = (
            <thead>
                <tr>
                    {columnDefinitions.map((columnDef, colIndex) => <th key={colIndex}>{columnDef.header}</th>)}
                </tr>
            </thead>
        );

        const tbody = () => {
            if (items.length === 0) {
                return(
                    <tbody>
                        <tr>
                            <td colSpan={columnDefinitions.length}>
                                {emptyState}
                            </td>
                        </tr>
                    </tbody>
                );
            }
            const body = items.map((item, rowIndex) => {
                return (
                    <tr key={rowIndex}>
                        {columnDefinitions.map((columnDef, colIndex) => tBodyCell(columnDef, item, rowIndex, colIndex))}
                    </tr>
                );
            });
            return (
                <tbody>{body}</tbody>
            );
        };

        const tBodyCell = ( columnDef: ColumnDefinition<any>, item: any, rowIndex: number, colIndex: number ) => {
            const cell = typeof columnDef.cell === 'function' ? columnDef.cell(item) : columnDef.cell;
            return (
                <td key={`${rowIndex}-${colIndex}`}>{cell}</td>
            );
        };

        return (
            <div className='awsui-table' id={tableId}>
                <div className='awsui-table-heading-container'>
                    <div className='awsui-table-regions-container'>
                        <div className='awsui-table-header'>
                            <span>{tableTitle}</span>
                        </div>
                    </div>
                </div>
                <div className='awsui-table-container'>
                    <table data-testid='native-html-table'>
                        {thead}
                        {tbody()}
                    </table>
                </div>
            </div>
        );
    }
}

export default NativeHtmlTable;
